module.exports = __webpack_public_path__ + "img/aegaming.8c112f3b.png";